import { createContext } from 'react';
import { IUserInfo } from '../resources/models/IUserInfo';

export interface ICurrentUserContext {
  userInfo: IUserInfo | null;
  refetchUserInfo: () => Promise<void>;
}

export const CurrentUserContext = createContext<ICurrentUserContext>({
  userInfo: null,
  refetchUserInfo: async () => void 0,
});
